import axios from 'config/axios'
import { ApiKey } from 'config/enums'
import { ApiEndpoints } from 'config/endpoints'
import { useQuery } from '@tanstack/react-query'
import { store } from 'config/user/store'

export const getLanguages = async () => {
  return axios.get(ApiEndpoints.getLanguage)
}

export const useGetLanguages = (options: { enabled: boolean }) => {
  const lang = store.getState().locale.lang

  return useQuery({
    queryKey: [ApiKey.Language, lang],
    queryFn: getLanguages,
    keepPreviousData: true,
    ...options,
  })
}
